<template>
  <div class="clazz_manage_detail" v-if="clazz">
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <div class="header bgwhite">
        <div class="cover_warp">
          <img class="cover" :src="cover">
          <van-uploader class="update_icon" :after-read="onReadUpload">
            <van-icon class="icon" name="photograph" />修改头图
          </van-uploader>
        </div>
        <div class="info">
          <div class="title">
            <span>{{ clazz.clazz_name }}</span>
            <van-icon class="ml1 highlight" name="edit" @click="editTitle" />
          </div>
          <!-- <div class="subinfo">
            {{ clazz.week_num }}周&nbsp;&nbsp;|&nbsp;&nbsp;
            {{ clazz.user_num }}人已参加&nbsp;&nbsp;|&nbsp;&nbsp;
            {{ clazz.record_num }}个打卡记录
          </div> -->
        </div>
      </div>

      <div class="clazz_panel mt15 bgwhite">
        <div class="title">
          <span>班级口号</span>
          <van-icon class="ml1 highlight" name="edit" @click="editKeywords" />
        </div>
        <div v-if="clazz.keywords" class="body">{{ clazz.keywords }}</div>
        <div v-else class="empty highlight"  @click="editKeywords">
          <van-icon class="icon" name="plus" />
          一句话描述班级，喊出你的班级口号
        </div>

      </div>

      <div class="clazz_panel mt15 bgwhite">
        <div class="title">
          <span><span style="color: red; margin-right: 2px;">*</span>班级介绍</span>
          <van-icon class="ml1 highlight" name="edit" @click="editIntro" />
        </div>
        <div v-if="clazz.intro" class="body">{{ clazz.intro }}</div>
        <div v-else class="empty highlight"  @click="editIntro">
          <van-icon class="icon" name="plus" />
          丰富班级介绍，让更多人了解你的班级
        </div>
      </div>

      <div class="clazz_panel mt15 bgwhite">
        <div class="title">
          <span><span style="color: red; margin-right: 2px;">*</span> 班长简介</span>
          <van-icon class="ml1 highlight" name="edit" @click="editCreater" />
        </div>
        <div v-if="clazz.creater_intro">
          <div class="leader">
            <img :src="clazz.creater.avatar_url" class="headimg">
            <div class="name">{{ clazz.creater.nickname }}</div>
          </div>
          <div class="body leader_intro">{{ clazz.creater_intro }}</div>
        </div>
        <div v-else class="empty highlight" @click="editCreater">
          <van-icon class="icon" name="plus" />
          完善班长介绍，让成员认识你
        </div>
      </div>
    </van-pull-refresh>

    <van-popup class="full_popup title_popup" v-model="titleShow" position="right">
      <van-field
        class="name_field1"
        label="班级名称"
        v-model="clazz.clazz_name"
        placeholder="请输入班级名称"
      />

      <bottom-btn class="mt2" title="保存" :fixed="false" @click.native="saveClazz" />
      <bottom-btn class="mt15" title="取消" :fixed="false" :cancel="true" @click.native="titleShow = false" />
    </van-popup>

    <van-popup class="full_popup keywords_popup" v-model="keywordsShow" position="right">
      <div class="check_len_input">
        <van-field class="field" v-model="clazz.keywords" clearable placeholder="请输入班级关键字" :maxlength="keywordsMaxLen" />
        <div class="check_label">
          {{ keywordsLen }}/{{ keywordsMaxLen }}
        </div>
      </div>
      <bottom-btn class="mt2" title="保存" :fixed="false" @click.native="saveClazz" />
      <bottom-btn class="mt15" title="取消" :fixed="false" :cancel="true" @click.native="keywordsShow = false" />
    </van-popup>

    <van-popup class="full_popup intro_popup" v-model="introShow" position="right">
      <div class="popup_header">班级介绍</div>
      <div class="check_len_textarea">
        <van-field v-model="clazz.intro" class="field" type="textarea" placeholder="请输入班级介绍" rows="5" />
        <div class="check_label">
          {{ introLen }}/{{ introMaxLen }}
        </div>
      </div>
      <bottom-btn class="mt2" title="保存" :fixed="false" @click.native="saveClazz" />
      <bottom-btn class="mt15" title="取消" :fixed="false" :cancel="true" @click.native="introShow = false" />
    </van-popup>

    <van-popup class="full_popup creater_popup" v-model="createrShow" position="right">
      <div class="popup_header">班长简介</div>
      <div class="check_len_textarea">
        <van-field v-model="clazz.creater_intro" class="field" type="textarea" placeholder="请输入班长简介" rows="5" />
        <div class="check_label">
          {{ createrLen }}/{{ createrMaxLen }}
        </div>
      </div>
      <div class="popup_header mt15">班长微信二维码</div>
      <div class="inline_field bgwhite">
        <van-uploader class="add_qrcode" :after-read="onQrcodeRead">
          <div v-if="weixinQrcodeUrl" class="photo">
            <img :src="weixinQrcodeUrl">
          </div>
          <van-icon v-else name="photograph" />
        </van-uploader>
        <div class="help_text" style="margin-top:10px">用于报名的用户联系班长</div>

        <!-- <van-field class="border_field" v-model="clazz.creater_weixin" placeholder="请输入班长微信号"/> -->
      </div>
      <bottom-btn class="mt2" title="保存" :fixed="false" @click.native="saveClazzCreater" />
      <bottom-btn class="mt15" title="取消" :fixed="false" :cancel="true" @click.native="createrShow = false" />
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Icon, Uploader, Popup, Field, PullRefresh, Toast } from 'vant'
// import { uploadImage } from '@/api/upload'
import BottomBtn from '@/components/BottomBtn'
import defaultClazzImg from '@/assets/images/default_clazz.jpg'
import { strLength } from '@/utils/index'
import cropper from '@/components/Cropper/cropper'
import { clazzSimpleInfo } from '@/api/clazz'
import { editClazz } from '@/api/clazz_manage'
import { uploadImageToOss } from '@/api/upload'
import { getUploadParams, base64ToFile } from '@/utils/upload'

export default {
  name: 'ClazzManageDetail',
  components: {
    [Icon.name]: Icon,
    [Uploader.name]: Uploader,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [PullRefresh.name]: PullRefresh,
    BottomBtn
  },
  data () {
    return {
      weixinQrcodeObj: null,
      weixinQrcodeUrl: null,
      loading: false,
      introLen: 0,
      introMaxLen: 200,
      keywordsLen: 0,
      keywordsMaxLen: 15,
      createrLen: 0,
      createrMaxLen: 100,
      show: false,
      titleShow: false,
      keywordsShow: false,
      introShow: false,
      createrShow: false,
      cover: defaultClazzImg,
      clazz: null
    }
  },
  watch: {
    clazz: {
      handler (clazz) {
        this.keywordsLen = clazz && clazz.keywords ? strLength(clazz.keywords) : 0
        this.introLen = clazz && clazz.intro ? strLength(clazz.intro) : 0
        this.createrLen = clazz && clazz.creater_intro ? strLength(clazz.creater_intro) : 0
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'ossToken'
    ]),
    hasCreaterInfo () {
      return this.clazz && this.clazz.creater_weixin && this.clazz.creater_intro
    }
  },
  created () {
    let clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo(clazzId)
  },
  methods: {
    async getClazzInfo (clazzId) {
      this.loading = true
      let response = await clazzSimpleInfo(clazzId)
      this.loading = false
      if (!response.data.is_manager) {
        this.$router.replace('/explore')
        return false
      }
      this.clazz = response.data
      this.cover = this.clazz.cover_url
      this.weixinQrcodeUrl = this.clazz.creater_weixin_qrcode
    },
    async onReadUpload (file) {
      let self = this
      cropper.clip(file, {
        aspectRatio: 2,
        onCropStart () {
          Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
        },
        async onUpload (data) {
          self.cover = data

          const file = base64ToFile(data, 'clazz.png')
          const filePath = await self.uploadClazzCover(file)

          self.clazz.cover = filePath
          await self.saveClazz()
        }
      })
    },
    async uploadClazzCover (fileObj) {
      await this.$store.dispatch('GetOssToken', 'clazz_cover')
      const formData = getUploadParams(this.ossToken, fileObj)

      await uploadImageToOss(this.ossToken.host, formData)
      return formData.get('key')
    },
    onQrcodeRead (file) {
      this.weixinQrcodeObj = file
      this.weixinQrcodeUrl = file.content
    },
    async uploadWxQrcode () {
      if (!this.weixinQrcodeObj) {
        return false
      }

      await this.$store.dispatch('GetOssToken', 'wx_qrcode')
      const formData = getUploadParams(this.ossToken, this.weixinQrcodeObj.file)
      await uploadImageToOss(this.ossToken.host, formData)

      this.clazz.creater_weixin = formData.get('key')
    },
    onRefresh () {
      let clazzId = this.$route.params.clazz_id || ''
      this.getClazzInfo(clazzId)
    },
    editTitle () {
      this.titleShow = true
    },
    editKeywords () {
      this.keywordsShow = true
    },
    editIntro () {
      this.introShow = true
    },
    editCreater () {
      this.createrShow = true
    },
    async saveClazzCreater () {
      await this.uploadWxQrcode()

      if (!this.clazz.creater_intro) {
        Toast({ message: '请完善班长简介', forbidClick: true })
        return false
      }

      if (!this.clazz.creater_weixin) {
        Toast({ message: '请上传班长微信二维码', forbidClick: true })
        return false
      }
      this.saveClazz()
    },
    async saveClazz () {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      let clazzId = this.clazz.uuid
      await editClazz(clazzId, this.clazz)
      Toast.clear()
      this.titleShow = false
      this.keywordsShow = false
      this.introShow = false
      this.createrShow = false
    }
  }
}
</script>

<style lang=scss src="@/components/Cropper/cropper.scss"></style>
<style lang="scss" scoped>
.clazz_manage_detail {
  background-color: #f8f8f8;
  .help_text {
    color: #5e6d82;
    font-size: 28px;
    padding: 0 30px;
  }
  .add_qrcode {
    width: 200px;
    height: 200px;
    margin-left: 30px;
    margin-top: 20px;
    box-sizing: border-box;
    border: 1PX solid #ebedf0;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 200px;
      height: 200px;
    }
  }
  .header {
    .cover_warp {
      position: relative;
      .cover {
        width: 750px;
        height: 375px;
        object-fit: cover;
      }
      .update_icon {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,0.5);
        color: #fff;
        border-radius: 6px;
        font-size: 30px;
        width: 180px;
        height: 50px;
        position: absolute;
        right: 20px;
        bottom: 20px;
        .icon {
          margin-right: 5px;
        }
      }
    }
    .info {
      padding: 25px;
      .title {
        font-size: 36px;
        font-weight: bold;
        height: 50px;
        display: flex;
        align-items: center;
      }
      .subinfo {
        font-size: 26px;
        color: #9c9c9c;
        margin-top: 10px;
      }
    }
  }
  .clazz_panel {
    padding-bottom: 25px;
    .empty {
      border: 1PX dotted #bbb;
      margin: 0px 25px 0 25px;
      height: 200px;
      font-size: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon {
        font-weight: 36px;
        font-weight: bold;
        margin-right: 10px;
      }
    }
    .title {
      font-size: 32px;
      font-weight: bold;
      padding: 25px;
    }
    .body {
      font-size: 28px;
      padding: 0 25px 0 25px;
    }
    .leader {
      display: flex;
      padding: 0 25px 0 25px;
      align-items: center;
      .headimg {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
      .name {
        font-size: 28px;
        font-weight: bold;
        margin-left: 15px;
        color: #5a728e;
      }
    }
    .leader_intro {
      margin-left: 95px;
    }
  }
}
.title_popup {
  .name_field {
    margin: 80px auto 0 auto;
    width: 90%;
    border: 1PX solid #bbb;
    border-radius: 10px;
    font-size: 30px;
  }
}
.intro_popup, .creater_popup {
  .popup_header {
    background: #fff;
    padding: 20px 0 0 25px;
    font-size: 32px;
    font-weight: bold;
  }
}
.creater_popup {
  .inline_field {
    padding: 15px 0;
  }
  .border_field {
    width: 400px;
    margin-left: 25px;
    border: 1PX solid #e2e2e2;
    border-radius: 10px;
  }
}
.check_len_input {
  display: flex;
  .check_label {
    display: flex;
    align-items: center;
    padding-right: 15px;
    font-size: 28px;
    background-color: #fff;
    color: #969799;
  }
}
.full_popup {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
}
</style>
